import React, { Component } from 'react'
import { connect } from 'react-redux'

const homeContainer = (ComposedComponent) => {
    class HomeContainer extends Component {
        render () {
            return (
                <ComposedComponent {...this.props} />
            )
        }
    }
    const mapStateToProps = ({
        langs: { indexLang },
    }) => ({
        indexLang,
    })

    return connect(mapStateToProps)(HomeContainer)
}

export default homeContainer
